import React from "react";

export default function Confirmation() {
  return (
    <div>
      <img alt="" className="panel-img" src={"./imgs/confirm.png"} />

      <h2>Thanks - your details have been sent to a Bright Expert</h2>
      <p>
        We will contact you to finalise the details and iron out any unexpected
        blips or mistakes. Recommendation is emailed and payment made via bank
        transfer.
      </p>
    </div>
  );
}
